<script setup lang="ts">
import { ZhPageTitle } from '@zerohuman/ui'
import DocsLink from '@/components/DocsLink.vue'
import ToolBindings from '@/components/ToolBindings.vue'

/**
 * #1762: Tools opens with one plain sentence; the bindings fold their explanation behind "How this works" under it.
 * Every other screen that embeds the bindings passes no intro and keeps the explanation as its lead paragraph.
 */
const TOOLS_INTRO = 'Connect the apps your teammates use. You choose what each one can do.'
</script>

<template>
	<section class="w-full space-y-4 p-8">
		<ZhPageTitle>
			Tools
			<template #meta><DocsLink path="/docs/tools" /></template>
		</ZhPageTitle>
		<ToolBindings :intro="TOOLS_INTRO" />
	</section>
</template>
